import styled from '@emotion/styled';
import { ob } from '../../onboardingV2.tokens';

export const Grid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 10px;
    padding: 2px;
    border-radius: ${ob.radius.md};
    outline: ${({ dragActive }) => (dragActive ? `2px dashed ${ob.color.brand}` : 'none')};
    outline-offset: 2px;
`;

export const Cell = styled.div`
    position: relative;
    aspect-ratio: 1 / 1;
    border-radius: 12px;
    overflow: hidden;
    background: ${ob.color.subtle};
    border: 1px solid ${ob.color.borderSubtle};

    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const MainBadge = styled.span`
    position: absolute;
    left: 6px;
    bottom: 6px;
    padding: 2px 8px;
    border-radius: ${ob.radius.pill};
    background: ${ob.color.brand};
    color: ${ob.color.surface};
    font-size: 11px;
    font-weight: 700;
`;

export const RemoveBtn = styled.button`
    position: absolute;
    top: 6px;
    right: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border: 0;
    border-radius: 50%;
    background: rgba(17, 24, 39, 0.65);
    color: ${ob.color.surface};
    font-size: 16px;
    cursor: pointer;

    &:focus-visible {
        outline: none;
        box-shadow: ${ob.focusRing};
    }
`;

export const AddCell = styled.button`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    aspect-ratio: 1 / 1;
    border: 1.5px dashed ${ob.color.border};
    border-radius: 12px;
    background: ${ob.color.subtle};
    color: ${ob.color.brand};
    font-family: ${ob.font.body};
    font-size: 12.5px;
    font-weight: 600;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    i {
        font-size: 22px;
    }

    ${ob.hover} {
        &:hover {
            border-color: ${ob.color.brand};
            background: ${ob.color.lime50};
        }
    }

    &:focus-visible {
        outline: none;
        box-shadow: ${ob.focusRing};
    }
`;

export const Busy = styled.div`
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    padding: 6px;
    color: ${ob.color.brand};
    font-size: 11px;
    font-weight: 600;
    text-align: center;

    i {
        font-size: 20px;
    }
`;
